import {removeProtocolFromUrl} from '../../../../libs/shared/helpers/src/browser/urlHelpers';
import {reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';
import {ApiTopic} from '../../../models/api/topicModel';
import {patchApiAsync, postApiAsync} from '../../../services/http/http';
import {HttpError} from '../../../services/http/httpError';
import {ThunkAsyncAction} from '../../appThunk';
import {getCompanyUrl} from '../company/companySelectors';
import {updateDataAction} from '../dataGroupsActions';
import {updateConversationsAction} from './updateConversationsActions';

export function createAndAddTopicToConversationsAsyncAction(
  conversationIds: ReadonlyArray<number>,
  link: string,
  name: string,
): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const {company} = getState().data;
    const url = `${company.url}/topics`;

    const body = {
      name: name || removeProtocolFromUrl(link),
      type: 'web',
      ext_link: link,
    };

    const topic = await postApiAsync(ApiTopic, url, body);

    return dispatch(addTopicToConversationsAction(conversationIds, topic.id));
  };
}

export function addTopicToConversationsAction(conversationIds: ReadonlyArray<number>, topicId: number) {
  return updateConversationsAction(conversationIds, {addTopics: [topicId]}, (conversation) => {
    const topicIds = [...conversation.topicIds, topicId];
    return {...conversation, topicIds};
  });
}

export function removeTopicFromConversationsAction(conversationIds: ReadonlyArray<number>, topicId: number) {
  return updateConversationsAction(conversationIds, {removeTopics: [topicId]}, (conversation) => ({
    ...conversation,
    topicIds: conversation.topicIds.filter((tId) => tId !== topicId),
  }));
}

export function updateTopicNameAsyncAction(topicId: number, name: string): ThunkAsyncAction {
  return async (dispatch, getState) => {
    const companyUrl = getCompanyUrl(getState());
    const url = `${companyUrl}/topics/${topicId}`;

    try {
      const updatedTopic = await patchApiAsync(ApiTopic, url, {name});

      dispatch(updateDataAction({topics: [updatedTopic]}));
    } catch (error) {
      if (!(error instanceof HttpError)) {
        reportToBugsnag(error);
      }
      throw error;
    }
  };
}
